import { Column } from '@ant-design/plots';
import React, { useEffect, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import PlotAutoFit from '../Layout/PlotAutoFit';

const ColumnChart1 = () => {
  const chartRef = useRef();
  useEffect(() => {
    console.log({ chartRef });
    if (chartRef.current) {
    }
  }, []);
  const config = {
    data: {
      type: 'fetch',
      value: 'https://gw.alipayobjects.com/os/bmw-prod/be63e0a2-d2be-4c45-97fd-c00f752a66d4.json',
    },
    xField: '城市',
    yField: '销售额',
    slider: {
      x: {
        values: [0.1, 0.2],
      },
    },
  };
  return (
  
 <PlotAutoFit>
      {({ width, height }) => (
        <Column
          {...config}
          autoFit={false}
          width={width}
          height={height}
        />
      )}
    </PlotAutoFit>

 
  );
};
export default ColumnChart1;
